import { createAdultRatesPending,createAdultRatesSuccess,createAdultRatesFail,createChildRatesFail,createChildRatesPending,
    createChildRatesSuccess,createInfantRatesPending,createInfantRatesFail,
    createInfantRatesSuccess,createSeasonalRatesFail,createSeasonalRatesPending,
    createSeasonalRatesSuccess ,createPromotionRatesFail,createPromotionRatesPending,createPromotionRatesSuccess,
    getSProductRateFail,getSProductRatePending,getSProductRateSuccess,deleteChildRateFail,deleteChildRatePending,
    deleteChildRateSuccess,deleteInfantRateFail,deleteInfantRatePending,deleteInfantRateSuccess,
modifyAdultRateFail,modifyAdultRatePending,modifyAdultRateSuccess,modifyChildRateFail,modifyChildRatePending,
modifyChildRateSuccess,modifyInfantRateFail,modifyInfantRatePending,modifyInfantRateSuccess,modifyPromotionRateFail,
modifyPromotionRatePending,modifyPromotionRateSuccess,modifySeasonalRateFail,modifySeasonalRatePending,modifySeasonalRateSuccess,
deletePromotionRateFail,deletePromotionRatePending,deletePromotionRateSuccess,deleteSeasonalRateFail,deleteSeasonalRatePending,
deleteSeasonalRateSuccess,approveProductRatesFail,approveProductRatesPending,approveProductRatesSuccess,
rejectProductRatesFail,rejectProductRatesPending,rejectProductRatesSuccess,getSAProductRateFail,getSAProductRatePending,getSAProductRateSuccess,
createHourRatesFail,createHourRatesPending,createHourRatesSuccess, modifyHourRateFail,modifyHourRatePending,modifyHourRateSuccess,createVehicleRatesFail,createVehicleRatesPending,createVehicleRatesSuccess,modifyVehicleRateFail,modifyVehicleRatePending,modifyVehicleRateSuccess } from "./ratesSlice";
    


    
import { productratesCreation,adultrateCreation,childrateCreation,infantrateCreation,
    seasonalrateCreation,promotionrateCreation, fetchSingleProductRate, childrateDelete,infantrateDelete,adultrateModify,childrateModify,infantrateModify,seasonalrateModify,promotionrateModify,seasonalrateDelete,promotionrateDelete,productratesReject,productratesApprove,fetchRateSingleView,hourrateCreation,hourrateModify,vehiclerateCreation,vehiclerateModify } from "../../../api/userApi";
import Swal from "sweetalert2";






export const newAdultRatesCreation = (frmDt) => async (dispatch) => {
    try {
        dispatch(createAdultRatesPending());
        const result = await adultrateCreation(frmDt);
        console.log(result);
        result.status === "success"
            ? dispatch(createAdultRatesSuccess(result.result1.base_product_id))
            : dispatch(createAdultRatesFail(result.message));

          
    } catch (error) {
        const err = JSON.parse(JSON.stringify(error.response.data.error));
         console.log(err);
         Swal.fire({
            title: 'Error!',
            text: err.msg,
            icon: 'error',
            confirmButtonText: 'Okay'
          })
        //console.log(error.response.data.error.msg);
         //console.log('catch block'+err.message);
        //console.log(JSON.parse(JSON.stringify(error)));
        dispatch(createAdultRatesFail(err.msg));
    }

}


export const newHourRatesCreation = (frmDt) => async (dispatch) => {
    try {
        dispatch(createHourRatesPending());
        const result = await hourrateCreation(frmDt);
        console.log(result);
        result.status === "success"
            ? dispatch(createHourRatesSuccess(result.result1.base_product_id))
            : dispatch(createHourRatesFail(result.message));

          
    } catch (error) {
        const err = JSON.parse(JSON.stringify(error.response.data.error));
         console.log(err);
         Swal.fire({
            title: 'Error!',
            text: err.msg,
            icon: 'error',
            confirmButtonText: 'Okay'
          })
        //console.log(error.response.data.error.msg);
         //console.log('catch block'+err.message);
        //console.log(JSON.parse(JSON.stringify(error)));
        dispatch(createHourRatesFail(err.msg));
    }

}


//vehicle rate

export const newVehicleRatesCreation = (frmDt) => async (dispatch) => {
    try {
        dispatch(createVehicleRatesPending());
        const result = await vehiclerateCreation(frmDt);
        console.log(result);
        result.status === "success"
            ? dispatch(createVehicleRatesSuccess(result.result1.base_product_id))
            : dispatch(createVehicleRatesFail(result.message));

          
    } catch (error) {
        const err = JSON.parse(JSON.stringify(error.response.data.error));
         console.log(err);
         Swal.fire({
            title: 'Error!',
            text: err.msg,
            icon: 'error',
            confirmButtonText: 'Okay'
          })
        //console.log(error.response.data.error.msg);
         //console.log('catch block'+err.message);
        //console.log(JSON.parse(JSON.stringify(error)));
        dispatch(createVehicleRatesFail(err.msg));
    }

}




export const newChildRatesCreation = (frmDt) => async (dispatch) => {
    try {
        dispatch(createChildRatesPending());
        const result = await childrateCreation(frmDt);
        console.log(result.status==="fail");
        result.status === "success"
            ? dispatch(createChildRatesSuccess(result.message))
            : dispatch(createChildRatesFail(result.message));

          
    } catch (error) {
        const err = JSON.parse(JSON.stringify(error.response.data.error));
         console.log(err);
         Swal.fire({
            title: 'Error!',
            text: err.msg,
            icon: 'error',
            confirmButtonText: 'Okay'
          })
        //console.log(error.response.data.error.msg);
         //console.log('catch block'+err.message);
        //console.log(JSON.parse(JSON.stringify(error)));
        dispatch(createChildRatesFail(err.msg));
    }

}


export const newInfantRatesCreation = (frmDt) => async (dispatch) => {
    try {
        dispatch(createInfantRatesPending());
        const result = await infantrateCreation(frmDt);
        console.log(result.status==="fail");
        result.status === "success"
            ? dispatch(createInfantRatesSuccess(result.message))
            : dispatch(createInfantRatesFail(result.message));

          
    } catch (error) {
        const err = JSON.parse(JSON.stringify(error.response.data.error));
         console.log(err);
         Swal.fire({
            title: 'Error!',
            text: err.msg,
            icon: 'error',
            confirmButtonText: 'Okay'
          })
        //console.log(error.response.data.error.msg);
         //console.log('catch block'+err.message);
        //console.log(JSON.parse(JSON.stringify(error)));
        dispatch(createInfantRatesFail(err.msg));
    }

}




export const newSeasonalRatesCreation = (frmDt) => async (dispatch) => {
    try {
        dispatch(createSeasonalRatesPending());
        const result = await seasonalrateCreation(frmDt);
        console.log(result.status==="fail");
        result.status === "success"
            ? dispatch(createSeasonalRatesSuccess(result.message))
            : dispatch(createSeasonalRatesFail(result.message));

          
    } catch (error) {
        const err = JSON.parse(JSON.stringify(error.response.data.error));
         console.log(err);
         Swal.fire({
            title: 'Error!',
            text: err.msg,
            icon: 'error',
            confirmButtonText: 'Okay'
          })
        //console.log(error.response.data.error.msg);
         //console.log('catch block'+err.message);
        //console.log(JSON.parse(JSON.stringify(error)));
        dispatch(createSeasonalRatesFail(err.msg));
    }

}



export const newPromotionRatesCreation = (frmDt) => async (dispatch) => {
    try {
        dispatch(createPromotionRatesPending());
        const result = await promotionrateCreation(frmDt);
        console.log(result.status==="fail");
        result.status === "success"
            ? dispatch(createPromotionRatesSuccess(result.message))
            : dispatch(createPromotionRatesFail(result.message));

          
    } catch (error) {
        const err = JSON.parse(JSON.stringify(error.response.data.error));
         console.log(err);
         Swal.fire({
            title: 'Error!',
            text: err.msg,
            icon: 'error',
            confirmButtonText: 'Okay'
          })
        //console.log(error.response.data.error.msg);
         //console.log('catch block'+err.message);
        //console.log(JSON.parse(JSON.stringify(error)));
        dispatch(createPromotionRatesFail(err.msg));
    }

}





export const getSingleProductRate = (id) => async (dispatch) => {
    console.log('act'+id);
 
    try {
     //call the api
    dispatch(getSProductRatePending());
    const result = await fetchSingleProductRate(id);
   // const userData=JSON.parse(result.user);
   console.log("result",result)
 //console.log('ProductCommissionData ');
 //console.log(result);
 //console.log(result.commissions);
 
 //console.log('check user profile out if');
    if(result.rates){
    //console.log('check user profile');
        return dispatch(getSProductRateSuccess(result.rates));
    }
    dispatch(getSProductRateFail("ProductRate is not found"));
 
   
 } catch (error) {
    dispatch(getSProductRateFail(error));
 
 }
    
 
 }




export const getRateSingleView = (id) => async (dispatch) => {
    console.log('act' + id);

    try {
        dispatch(getSAProductRatePending());
        const result = await fetchRateSingleView(id);

        if (result.rates) {
            return dispatch(getSAProductRateSuccess(result.rates));
        }
        dispatch(getSAProductRateFail("ProductRate is not found"));


    } catch (error) {
        dispatch(getSAProductRateFail(error));

    }


}




 //child rate deletion for dynamic form


 export const childrateDeletion = (frmDt) => async(dispatch) => {

    try {
        dispatch(deleteChildRatePending());
        const result = await childrateDelete(frmDt);
   
        result.status ==="success" 
        ? dispatch(deleteChildRateSuccess("Child Rate deleted"))
        : dispatch(deleteChildRateFail(result.message));
        
    } catch (error) {
       const err = JSON.parse(JSON.stringify(error.response.data.error));
       dispatch(deleteChildRateFail(err.msg));
    }
    
}





 //infant rate deletion for dynamic form


 export const infantrateDeletion = (frmDt) => async(dispatch) => {

    try {
        dispatch(deleteInfantRatePending());
        const result = await infantrateDelete(frmDt);
   
        result.status ==="success" 
        ? dispatch(deleteInfantRateSuccess("Infant Rate deleted"))
        : dispatch(deleteInfantRateFail(result.message));
        
    } catch (error) {
       const err = JSON.parse(JSON.stringify(error.response.data.error));
       dispatch(deleteInfantRateFail(err.msg));
    }
    
}




 //seasonal rate deletion for dynamic form


 export const seasonalrateDeletion = (frmDt) => async(dispatch) => {

    try {
        dispatch(deleteSeasonalRatePending());
        const result = await seasonalrateDelete(frmDt);
   
        result.status ==="success" 
        ? dispatch(deleteSeasonalRateSuccess("Infant Rate deleted"))
        : dispatch(deleteSeasonalRateFail(result.message));
        
    } catch (error) {
       const err = JSON.parse(JSON.stringify(error.response.data.error));
       dispatch(deleteSeasonalRateFail(err.msg));
    }
    
}






 //promotion rate deletion for dynamic form


 export const promotionrateDeletion = (frmDt) => async(dispatch) => {

    try {
        dispatch(deletePromotionRatePending());
        const result = await promotionrateDelete(frmDt);
   
        result.status ==="success" 
        ? dispatch(deletePromotionRateSuccess("Infant Rate deleted"))
        : dispatch(deletePromotionRateFail(result.message));
        
    } catch (error) {
       const err = JSON.parse(JSON.stringify(error.response.data.error));
       dispatch(deletePromotionRateFail(err.msg));
    }
    
}



//adult modification code

export const adultrateModification = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(modifyAdultRatePending());
        const result = await adultrateModify(frmDt);
        result.status === "success"
            ? dispatch(modifyAdultRateSuccess(result.message))
            : dispatch(modifyAdultRateFail(result.message));

    } catch (error) {
        const err = JSON.parse(JSON.stringify(error.response.data.error));
     
        dispatch(modifyAdultRateFail(err.msg));
    }

}




//hour modification code

export const hourrateModification = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(modifyHourRatePending());
        const result = await hourrateModify(frmDt);
        result.status === "success"
            ? dispatch(modifyHourRateSuccess(result.message))
            : dispatch(modifyHourRateFail(result.message));

    } catch (error) {
        const err = JSON.parse(JSON.stringify(error.response.data.error));
     
        dispatch(modifyHourRateFail(err.msg));
    }

}


//vehcile modification code


export const vehiclerateModification = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(modifyVehicleRatePending());
        const result = await vehiclerateModify(frmDt);
        result.status === "success"
            ? dispatch(modifyVehicleRateSuccess(result.message))
            : dispatch(modifyVehicleRateFail(result.message));

    } catch (error) {
        const err = JSON.parse(JSON.stringify(error.response.data.error));
     
        dispatch(modifyVehicleRateFail(err.msg));
    }

}


//child modification code

export const childrateModification = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(modifyChildRatePending());
        const result = await childrateModify(frmDt);
        result.status === "success"
            ? dispatch(modifyChildRateSuccess(result.message))
            : dispatch(modifyChildRateFail(result.message));

    } catch (error) {
        const err = JSON.parse(JSON.stringify(error.response.data.error));
     
        dispatch(modifyChildRateFail(err.msg));
    }

}



//infant modification code

export const infantrateModification = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(modifyInfantRatePending());
        const result = await infantrateModify(frmDt);
        result.status === "success"
            ? dispatch(modifyInfantRateSuccess(result.message))
            : dispatch(modifyInfantRateFail(result.message));

    } catch (error) {
        const err = JSON.parse(JSON.stringify(error.response.data.error));
     
        dispatch(modifyInfantRateFail(err.msg));
    }

}






//seasonal modification code

export const seasonalrateModification = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(modifySeasonalRatePending());
        const result = await seasonalrateModify(frmDt);
        result.status === "success"
            ? dispatch(modifySeasonalRateSuccess(result.message))
            : dispatch(modifySeasonalRateFail(result.message));

    } catch (error) {
        const err = JSON.parse(JSON.stringify(error.response.data.error));
     
        dispatch(modifySeasonalRateFail(err.msg));
    }

}




//promotion modification code

export const promotionrateModification = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(modifyPromotionRatePending());
        const result = await promotionrateModify(frmDt);
        result.status === "success"
            ? dispatch(modifyPromotionRateSuccess(result.message))
            : dispatch(modifyPromotionRateFail(result.message));

    } catch (error) {
        const err = JSON.parse(JSON.stringify(error.response.data.error));
     
        dispatch(modifyPromotionRateFail(err.msg));
    }

}




//Approval



export const productratesApproved = (frmDt) => async(dispatch) => {

    try {
        dispatch(approveProductRatesPending());
        const result = await productratesApprove(frmDt);
       
        result.status ==="success" 
        ? dispatch(approveProductRatesSuccess("ProductRates approved"))
        : dispatch(approveProductRatesFail(result.message));
        
    } catch (error) {
       const err = JSON.parse(JSON.stringify(error.response.data.error));
      
        dispatch(approveProductRatesFail(err.msg));
    }
    
}


export const productratesRejected = (frmDt) => async(dispatch) => {

    try {
        dispatch(rejectProductRatesPending());
        const result = await productratesReject(frmDt);
  
        result.status ==="success" 
        ? dispatch(rejectProductRatesSuccess("ProductCommission rejected"))
        : dispatch(rejectProductRatesFail(result.message));
        
    } catch (error) {
       const err = JSON.parse(JSON.stringify(error.response.data.error));
  
        dispatch(rejectProductRatesFail(err.msg));
    }
    
}